/**
 * Lazy adapter registry, keyed by WalletProviderKind.
 *
 * Each loader is a dynamic `import()` so a deployment only pulls in the SDK for
 * its active chain — e.g. the DogeOS build never ships Privy or Para code. The
 * active kind is resolved once from `REACT_APP_CHAIN_ID` (build-time single chain),
 * but the registry is keyed by kind so it trivially extends to future chains.
 */
import { WalletProviderKind } from "../../../enums/walletProvider";
import type { WalletAdapter } from "./types";

type AdapterModule = { default: WalletAdapter };

export const WALLET_ADAPTER_LOADERS: Record<
  WalletProviderKind,
  () => Promise<AdapterModule>
> = {
  [WalletProviderKind.WEB3REACT]: () => import("./web3react/adapter"),
  [WalletProviderKind.PRIVY]: () => import("./privy/adapter"),
  [WalletProviderKind.PARA]: () => import("./para/adapter"),
  [WalletProviderKind.DOGEOS]: () => import("./dogeos/adapter"),
};

export const loadWalletAdapter = (
  kind: WalletProviderKind
): Promise<AdapterModule> => WALLET_ADAPTER_LOADERS[kind]();
